import moment from 'moment'

export function getRangeForWindow (start, end) {
  const startM = moment(start)
  const endM = moment(end)
  return endM.diff(startM, 'hours', true)
}

const changeTimeZoneToLocal = function (time) {
  return moment.utc(time).local().format()
}

export function groupAlertsIntoVisBlocks (detections, range, window) {
  let output = []
  const filtered = Object.entries(detections).filter(block => {
    if (block[0] >= window.start && block[0] <= window.end) {
      return block
    }
  })
  if (range <= 6) {
    // console.log('<= SIX HOURS')
    filtered.forEach(block => {
      const mapped = block[1].map(detection => {
        const start = changeTimeZoneToLocal(detection.start)
        const end = changeTimeZoneToLocal(detection.end)
        return Object.assign({}, detection, { start, end })
      })
      output = output.concat(mapped)
    })
  } else if (range <= 120) {
    // console.log('<= FIVE DAYS')
    let deciMinuteDict = {}
    filtered.forEach(block => {
      if (deciMinuteDict[block[0].substring(0, 15)]) {
        deciMinuteDict[block[0].substring(0, 15)] = deciMinuteDict[block[0].substring(0, 15)].concat(block[1])
      } else {
        deciMinuteDict[block[0].substring(0, 15)] = block[1]
      }
    })
    output = Object.entries(deciMinuteDict).map(block => {
      const bloc = {
        className: 'block',
        group: 1,
        id: block[0],
        start: changeTimeZoneToLocal(`${block[0]}0:00`),
        end: changeTimeZoneToLocal(block[1][block[1].length - 1].end),
        title: `${block[1].length} detections`,
        type: 'range',
        content: '',
      }
      return bloc
    })
  } else if (range <= 730) {
    // console.log('<= 7 DAYS')
    let hourDict = {}
    filtered.forEach(block => {
      if (hourDict[block[0].substring(0, 13)]) {
        hourDict[block[0].substring(0, 13)] = hourDict[block[0].substring(0, 13)].concat(block[1])
      } else {
        hourDict[block[0].substring(0, 13)] = block[1]
      }
    })
    output = Object.entries(hourDict).map(block => {
      const bloc = {
        className: 'block',
        group: 1,
        id: block[0],
        start: changeTimeZoneToLocal(`${block[0]}:00:00`),
        end: changeTimeZoneToLocal(block[1][block[1].length - 1].end),
        title: `${block[1].length} detections`,
        type: 'range',
        content: '',
      }
      return bloc
    })
  } else {
    // console.log('<= 7 DAYS')
    let daysDict = {}
    filtered.forEach(block => {
      if (daysDict[block[0].substring(0, 10)]) {
        daysDict[block[0].substring(0, 10)] = daysDict[block[0].substring(0, 10)].concat(block[1])
      } else {
        daysDict[block[0].substring(0, 10)] = block[1]
      }
    })
    output = Object.entries(daysDict).map(block => {
      const bloc = {
        className: 'block',
        group: 1,
        id: block[0],
        start: changeTimeZoneToLocal(`${block[0]} 00:00:00`),
        end: changeTimeZoneToLocal(block[1][block[1].length - 1].end),
        title: `${block[1].length} detections`,
        type: 'range',
        content: '',
      }
      return bloc
    })
  }
  return output
}
